import React from 'react';
import { Icon, Text, SocialMediaLink } from '@perch-labs/shrike';
import { SHARE_URL } from 'domain/advocacy';
import { copyFor } from 'config';
import { Container, Card } from 'styles';
import { StyledButton } from './advocacy-share.style';

const getCopy = copyFor('solar.advocacyShare');
const getSocialCopy = copyFor('social');

interface Props {
  title: string;
  description: string;
  icon?: React.ReactNode;
  margin?: Margin;
  shareCopy: string;
  socialShareCopy: string;
}

export const AdvocacyShare: React.FunctionComponent<Props> = ({
  description,
  icon,
  margin,
  shareCopy,
  socialShareCopy,
  title,
}: Props) => {
  const intitiateEmail = () => {
    window.open(
      `mailto:?subject=Support clean energy!&body=${socialShareCopy}`
    );
  };
  return (
    <Card mobileVariant="flat" margin={margin}>
      <Card.Header title={title} icon={icon} />
      <Card.Content>
        <Text margin={{ bottom: '32px' }}>{description}</Text>
        <Text margin={{ bottom: '8px' }} textStyle="heading500">
          {shareCopy}
        </Text>
        <Container>
          <StyledButton
            backgroundless
            margin={{ right: '8px' }}
            onClick={intitiateEmail}
            aria-label={getSocialCopy('share', { platform: 'email' })}
          >
            <Icon icon="Envelope" margin={{ right: '8px' }} />
            {getCopy('ctas.email')}
          </StyledButton>
          <SocialMediaLink
            platform="facebook"
            url={SHARE_URL}
            margin={{ right: '8px' }}
            size="small"
            aria-label={getSocialCopy('share', { platform: 'Facebook' })}
          >
            {getCopy('ctas.facebook')}
          </SocialMediaLink>
          <SocialMediaLink
            platform="twitter"
            text={socialShareCopy}
            url={SHARE_URL}
            hashtags="solar,arcadia"
            margin={{ top: '8px' }}
            size="small"
            aria-label={getSocialCopy('share', { platform: 'Twitter' })}
          >
            {getCopy('ctas.twitter')}
          </SocialMediaLink>
        </Container>
      </Card.Content>
    </Card>
  );
};
